module.exports = __webpack_public_path__ + "static/media/ic_reload.d03de875.svg";